<template>
  <div class="tos-confirmation-checkbox">
    <QrCheckbox
      :id="checkboxId"
      v-model="internalValue"
      color="navy"
      :error-state="showError"
      :disabled="disabled"
      @click.stop
    >
      <template #label>
        <span class="tos-confirmation-checkbox__label d-inline-block">
          {{ $t('fields.checkout.form.tos_confirmation_checkbox.label') }}
          <a
            href="https://www.qr-code-generator.com/company/terms/"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ $t('fields.checkout.form.tos_confirmation_checkbox.terms_of_service_label') }}</a
          >,
          <a
            href="https://www.qr-code-generator.com/company/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ $t('fields.checkout.form.tos_confirmation_checkbox.data_policy_label') }}</a
          >,
          <a
            href="https://www.qr-code-generator.com/company/acceptable-use-policy/"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ $t('fields.checkout.form.tos_confirmation_checkbox.acceptable_use_policy_label') }}</a
          >
          {{ $t('fields.checkout.form.tos_confirmation_checkbox.word_and') }}
          <a
            href="https://www.qr-code-generator.com/company/data-processing-agreement/"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ $t('fields.checkout.form.tos_confirmation_checkbox.data_processing_agreement_label') }}</a
          >
          {{ $t('fields.checkout.form.tos_confirmation_checkbox.word_and') }}
          <a
            href="https://www.qr-code-generator.com/company/automatic-renewal-terms/"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ $t('fields.checkout.form.tos_confirmation_checkbox.automatic_renewal_terms_label') }}</a
          >.
        </span>
      </template>
    </QrCheckbox>
    <div v-if="inlineError && showError" class="tos-confirmation-checkbox__error">
      {{ $t('fields.checkout.form.tos_confirmation_error') }}
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import QrCheckbox from '@/components/Input/QrCheckbox.vue';

@Component({
  components: {
    QrCheckbox,
  },
})
export default class CheckoutTosCheckbox extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly value!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly showError!: boolean;

  @Prop({ type: String, default: 'tos-confirmation-checkbox' })
  readonly checkboxId!: string;

  @Prop({ type: Boolean, default: true })
  readonly inlineError!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  internalValue = this.value;

  @Watch('value')
  onValueChange(val: boolean): void {
    this.internalValue = val;
  }

  // Keep v-model in sync and offer a change hook for consumers.
  @Watch('internalValue')
  onInternalValueChange(val: boolean): void {
    this.$emit('input', val);
    this.$emit('change', val);
  }
}
</script>

<style lang="scss" scoped>
.tos-confirmation-checkbox {
  &__label {
    color: map-get($lapis, 'lighten-2');

    a {
      color: map-get($lapis, 'lighten-2');
    }
  }

  &__error {
    margin-top: 4px;
    font-size: 12px;
    color: map-get($begonia, 'base');
  }
}
</style>
